import StoryblokButton from "components/DynamicComponent/atoms/StoryblokButton"

export default function DualCTA({ blok }) {
  return (
    <div className="flex flex-col lg:flex-row gap-x-4 items-start">
      {blok.buttons.map((button, idx) => (
        <StoryblokButton blok={button} key={idx} />
      ))}
    </div>
  )
}
